import { vehicleExtrasService } from '@/api/vehicle-extras.service';
import type {
  CreateVehicleExtraDto,
  FindAllVehicleExtrasQueryDto,
  UpdateVehicleExtraDto,
} from '@/entities/vehicle-extra.entity';
import { useMutation, useQuery } from '@tanstack/vue-query';
import type { EditAutoAssignVehicleExtraDto } from '@carvia/ros-client-types';

const QUERY_KEY = 'vehicle-extras';

export const useVehicleExtra = (id: string) => {
  return useQuery({
    queryKey: [QUERY_KEY, id],
    queryFn: () => vehicleExtrasService.getOne(id),
  });
};

export const useVehicleExtras = (query: FindAllVehicleExtrasQueryDto) => {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => vehicleExtrasService.getAllWithQuery(query),
  });
};

export const useUpdateVehicleExtra = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({ id, extra }: { id: string; extra: UpdateVehicleExtraDto }) =>
      vehicleExtrasService.update(id, extra),
  });
};

export const useEditAutoAssignVehicleExtra = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({ dto }: { dto: EditAutoAssignVehicleExtraDto }) =>
      vehicleExtrasService.editAutoAssignVehicleExtra(dto),
  });
};

export const useCreateVehicleExtra = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: (extra: CreateVehicleExtraDto) => vehicleExtrasService.create(extra),
  });
};
